/**
 * Public Layout – minimal layout for shareable public pages (e.g. /pricing, /pricing/compare)
 * No navbar, no left pane, no bottom nav – content only.
 *
 * @author Varun Pandey
 */

import React from 'react';

export interface PublicLayoutProps {
  children: React.ReactNode;
}

export const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-[#0B0B0D] text-white flex flex-col">
      <main className="flex-1 w-full min-h-screen">
        {children}
      </main>
    </div>
  );
};
